import { useNavigate } from 'react-router-dom';
import { useForm } from 'react-hook-form';

import { login } from '../../_util/api';
import useAxios from '../../hooks/useAxios';
import useAuth from '../../hooks/useAuth';
import { Else, If, Then } from 'react-if';
import useToasts from '../../hooks/useToasts';

function hideAuthModal() {
  const backdrop = document.querySelector('.modal-backdrop');
  if (backdrop) {
    backdrop.remove(); // Remove the modal backdrop if user is not null
    const body = document.querySelector('body');
    body.style.overflow = 'auto';
    body.style.padding = '0px';
  }
}

const LoginModal = ({ setErrorMessage, setIsLogin, userType, onForgotPassword }) => {
  const navigate = useNavigate();
  const auth = useAuth();
  const { addToast } = useToasts();
  const { isLoading, makeRequest } = useAxios({
    onSuccess: (data) => {
      auth.loginUser({ ...data, userType: userType });

      const isBuyBoostButtonClicked = localStorage.getItem('buy-boost-button-clicked');
      const isBuyAccountButtonClicked = localStorage.getItem('buy-account-clicked');
      if (!isBuyBoostButtonClicked && !isBuyAccountButtonClicked) {
        //when direct login then it should redirect to the dashboard
        navigate('/admin/dashboard');
      } else {
        // login if user is not login and try to place order
        addToast('Login successfull. Redirecting to Stripe...', 'success');
        // setErrorMessage('');
      }
      hideAuthModal();
    },
    onError: (err) => setErrorMessage(err),
  });

  const {
    register,
    handleSubmit,
    formState: { errors },
  } = useForm();

  const onLoginSubmit = (data) => {
    makeRequest(login(data, userType));
  };
  // const [forgotPassword, setForgotPassword] = useState(false);

  return (
    <form onSubmit={handleSubmit(onLoginSubmit)} autoComplete="off">
      <div className="col-12 pt-10 pb-5">
        <label htmlFor="Mail" id="Mail" className="form-label">
          Mail
        </label>
        <input
          type="email"
          className="form-control"
          placeholder="Insert your email"
          {...register('email', {
            required: 'Email is required',
            pattern: {
              value:
                /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/,
              message: 'Please enter a valid email',
            },
          })}
        />
        <div style={{ color: 'red' }}>{errors.email?.message}</div>
      </div>
      <div className="col-12 pt-10 pb-5">
        <label htmlFor="Password" id="Password" className="form-label">
          Password
        </label>
        <input
          type="password"
          className="form-control"
          placeholder="Insert your password"
          {...register('password', {
            required: 'Password is required',
          })}
        />
        <div style={{ color: 'red' }}>{errors.password?.message}</div>
      </div>

      <div className="col-12 pt-5 pb-5 text-right">
        <span
          role="button"
          style={{ fontSize: '12px' }}
          onClick={() => onForgotPassword(true)}
          className="my-mh-link text-brand-gradient"
        >
          Forgot Password?
        </span>
      </div>
      <button type="submit" className="btn btn-primary mb-0 my-font">
        {isLoading && (
          <div className="spinner-border text-dark" role="status">
            <span className="sr-only"></span>
          </div>
        )}
        {!isLoading && 'Login'}
      </button>
      <If condition={userType === 'booster'}>
        <Then>
          <p className="d-flex justify-content-center mt-3 mb-0">
            No account yet?&nbsp;
            <a
              href="https://discord.gg/YVDzNAc3cp"
              rel="noreferrer"
              target="_blank"
              className="text-brand-gradient"
            >
              Contact Us
            </a>
          </p>
        </Then>
        <Else>
          <p className="d-flex justify-content-center mt-3 mb-0">
            No account yet?&nbsp;
            <span
              role="button"
              className="my-mh-link text-brand-gradient"
              onClick={() => setIsLogin(false)}
            >
              <strong>Register here</strong>
            </span>
          </p>
        </Else>
      </If>
    </form>
  );
};

export default LoginModal;
